import {useInitModule} from './useInitModule';

const EntryPage = () => {
    useInitModule();

    return (
        <div className='flex h-screen w-full items-center justify-center bg-hard-white dark:bg-orion-1'>
            <div className='h-8 w-8 animate-loader-spin rounded-full border-2 border-orion-4 border-t-transparent' />
        </div>
    );
};

export default EntryPage;
